import React from 'react';
import Icon from '@mdi/react';
import { mdiPencil } from '@mdi/js';

const EditIcon = (props) => {
  return <Icon path={mdiPencil} {...props} />;
};

export default EditIcon;
